import React from 'react';

const styles = {
	outerWrap: {
		marginTop: 'calc(0.1 * 100vh)',
		minHeight: 'calc(0.63 * 100vh)',
	},
};

const MainContent = (props) => {
	return (
		<div className="container p-5" style={styles.outerWrap}>
			{props.children}
		</div>
	);
};

export default MainContent;



// WEBPACK FOOTER //
// ./src/components/common/MainContent.js